import { render, staticRenderFns } from "./GarageDoorImpacts.vue?vue&type=template&id=2615cf87&scoped=true"
import script from "./GarageDoorImpacts.vue?vue&type=script&lang=ts"
export * from "./GarageDoorImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2615cf87",
  null
  
)

export default component.exports